import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TvScreenService } from '../../services/tv-screen.service';

@Component({
  selector: 'ts-infosystem-weather',
  templateUrl: './infosystem-weather.component.html',
  styleUrls: ['./infosystem-weather.component.css'],
  imports: [NgIf],
})
export class InfosystemWeatherComponent {
  @Input() lat: number;
  @Input() lng: number;

  weather: any = null;
  temperature = 0;

  constructor(private tvScreenSrv: TvScreenService) {
    // Weather now comes from the BFF (key moved server-side), via the shared poll.
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      this.weather = payload?.weather ?? null;
      this.temperature = this.weather ? Math.round(this.weather.main.temp) : 0;
    });
  }
}
